/** core libraries & third party packages */
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";

/** icons */
// import { IoFilter } from "react-icons/io5";
// import { IoClose } from "react-icons/io5";
// import { IoIosCheckmark } from "react-icons/io";

/** component */
import ProductsPageCard from "../../components/common/product-card/ProductsPageCard";

/** custom hooks & query & context */
import { useProductQuery } from "../../hooks/useReactQuery";

/** utils */

/** style */
import "./Products.scss";

/** interfaces */
import { IProduct } from "../../Interfaces/product";

// const priceOptions = [
//   { id: "all", label: "All price", range: [1] },
//   { id: "0-999", label: "Less than 1,000", range: [0, 999] },
//   { id: "1k-3k", label: "1,000 - 3,000", range: [1000, 3000] },
//   { id: "3k-5k", label: "3,000 - 5,000", range: [3000, 5000] },
//   { id: "5k-7k", label: "5,000 - 7,000", range: [5000, 7000] },
//   { id: "moreThen7k", label: "More than 7,000", range: [7000, Infinity] },
// ];

const Products: React.FC = () => {
  // const [isMobileFilterMenuModal, setIsMobileFilterMenuModal] = useState(false);
  // const [selectedColors, setSelectedColors] = useState<string[]>([]);
  // const [selectedSizes, setSelectedSizes] = useState<number[]>([]);
  // const colors = ["Purple", "Black", "White", "Yellow", "Brown", "Gray"];
  // const sizes = [6, 7, 8, 9, 10];
  // const [selectedCategory, setSelectedCategory] = useState<string | null>(
  //   "All Categories"
  // );
  // const [selectedPriceRangeId, setSelectedPriceRangeId] =
  //   useState<string>("all");
  const [allProductsData, setAllProductsData] = useState<IProduct[]>([]);
  const [currentItems, setCurrentItems] = useState<IProduct[]>([]);
  const [currentPage, setCurrentPage] = useState(0);
  const productItemsPerPage = 12;

  const { Prefetch: getAllProductsQuery } = useProductQuery();
  const getAllProducts = getAllProductsQuery();

  const totalPages = Math.ceil(allProductsData.length / productItemsPerPage);

  useEffect(() => {
    const startOffset = currentPage * productItemsPerPage;
    const endOffset = startOffset + productItemsPerPage;
    const currentPageData = allProductsData.slice(startOffset, endOffset);
    setCurrentItems(currentPageData);
  }, [currentPage, allProductsData]);

  // useEffect(() => {
  //   if (getAllProducts.data !== undefined) {
  //     const filterProducts = getAllProducts.data.data.filter((product) => {
  //       const matchCategory =
  //         !selectedCategory || selectedCategory === "All Categories"
  //           ? true
  //           : product.category?.toLowerCase() ===
  //             selectedCategory.toLowerCase();

  //       const selectedRange = priceOptions.find(
  //         (opt) => opt.id === selectedPriceRangeId
  //       )?.range;

  //       const matchPriceRange =
  //         !selectedRange || selectedRange.length === 1
  //           ? true
  //           : selectedRange &&
  //             product.price >= selectedRange[0] &&
  //             product.price <= selectedRange[1];

  //       const matchSize =
  //         selectedSizes.length > 0
  //           ? product.variantOptions.some((variant) =>
  //               variant.sizes.some((size) => selectedSizes.includes(size.size))
  //             )
  //           : true;

  //       const matchColor =
  //         selectedColors && selectedColors.length > 0
  //           ? product.variantOptions.some((variant) =>
  //               selectedColors.includes(variant.color)
  //             )
  //           : true;

  //       return matchCategory && matchSize && matchPriceRange && matchColor;
  //     });
  //     setAllProductsData(filterProducts);
  //   }
  // }, [
  //   selectedCategory,
  //   selectedPriceRangeId,
  //   selectedSizes,
  //   selectedColors,
  //   getAllProducts.data,
  // ]);

  useEffect(() => {
    if (getAllProducts.data !== undefined) {
      setAllProductsData(getAllProducts.data.data);
    }
  }, [getAllProducts.data]);

  const handlePageChange = (event: {
    selected: React.SetStateAction<number>;
  }) => {
    setCurrentPage(event.selected);
  };

  // const handleSelectedCategory = (category: string) => {
  //   if (selectedCategory === category) {
  //     setSelectedCategory("All Categories");
  //   } else {
  //     setSelectedCategory(category);
  //   }
  // };
  // const handleSelectPriceRange = (id: string) => {
  //   setSelectedPriceRangeId((prev) => (prev === id ? "all" : id));
  // };

  // const handleSelectedColor = (color: string) => {
  //   setSelectedColors((prev) =>
  //     prev.includes(color)
  //       ? prev.filter((val) => val !== color)
  //       : [...prev, color]
  //   );
  // };

  // const handleSelectedSizes = (size: number) => {
  //   setSelectedSizes((prev) =>
  //     prev.includes(size) ? prev.filter((val) => val !== size) : [...prev, size]
  //   );
  // };

  // const handleMobileFilterMenuModal = () => {
  //   setIsMobileFilterMenuModal((prev) => !prev);
  // };

  return (
    <>
      <div className="products_page w-[96%]">
        <div className="products_page_container">
          <div className="breadcrumb_container">
            <div className="w-full select-none">
              <img
                src="/assets/products/about-banner-1.png"
                alt="about-banner"
                loading="lazy"
                className="w-full sm:rounded-[48px] sm:h-auto h-[180px] rounded-[30px] object-cover"
              />
            </div>
            <div className="breadcrumb_content">
              <div className="text-white sm:text-[24px] text-[14px] font-medium">
                Limited time only
              </div>
              <div className="xl:text-[74px] sm:text-[35px] text-[22px]  font-semibold text-white">
                Get 30% off
              </div>
              <div className="text-white xl:text-[20px] text-[10px] font-normal">
                Sneakers made with your comfort in mind so you can put all of
                your focus into your next session.
              </div>
            </div>
          </div>
          <div className="flex gap-3 sm:mt-[100px] mt-[10px]">
            {/* <div className="left_filter_card custom_scrollbar">
              <div className="flex gap-1 items-center relative">
                <div className="lg:text-[17px] text-[15px] font-medium tracking-widest uppercase relative">
                  Filters
                  <span className="absolute top-1/2 left-[-10px] w-[2px] h-[30px]  bg[var(--text-gray-color)] bg-[#232321] transform -translate-y-1/2 z-[999]"></span>
                </div>
              </div>

              <div className="flex flex-col gap-7 pt-8">
                <div className="filter">
                  <div className="filter_title relative">CATEGORIES</div>
                  <div className="flex flex-col gap-[6px] pt-5 categories">
                    {[
                      "All Categories",
                      "Sneakers",
                      "Running Shoes",
                      "Casual Shoes",
                      "Formal Shoes",
                    ].map((category) => (
                      <div
                        key={category}
                        className={`category ${
                          selectedCategory === category ? "active" : ""
                        }`}
                        onClick={() => handleSelectedCategory(category)}
                      >
                        {category}
                      </div>
                    ))}
                  </div>
                </div>

                <div className="filter">
                  <div className="filter_title relative">PRICE</div>
                  <div className="flex flex-col gap-[6px] pt-5 categories">
                    {priceOptions.map((option, index) => {
                      return (
                        <div
                          className="flex justify-between items-center"
                          key={index}
                        >
                          <div
                            className={`category ${
                              selectedPriceRangeId === option.id ? "active" : ""
                            }`}
                            onClick={() => handleSelectPriceRange(option.id)}
                          >
                            {option.label}
                          </div>
                          <div className="checkbox-wrapper-46">
                            <input
                              type="checkbox"
                              checked={selectedPriceRangeId === option.id}
                              id={`cbx-46`}
                              className="inp-cbx"
                              readOnly
                            />
                            <label htmlFor={`cbx-46`} className="cbx">
                              <span>
                                <svg
                                  viewBox="0 0 12 10"
                                  height="10px"
                                  width="12px"
                                >
                                  <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                </svg>
                              </span>
                            </label>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="filter">
                  <div className="filter_title flex gap-2 relative">SIZE</div>
                  <div className="flex items-center gap-2 flex-wrap pt-5 justify-between">
                    <div className="flex  lg:justify-between items-center lg:gap-2 gap-3  flex-1 flex-wrap">
                      {sizes.map((size, index) => {
                        return (
                          <div
                            key={index}
                            className="w-[43px] h-[37px]"
                            onClick={() => handleSelectedSizes(size)}
                          >
                            <div
                              className={`borde borderblack rounded-md w-full h-full flex justify-center bg-white items-center text-black ${
                                selectedSizes.includes(size) &&
                                "!bg-black !text-white"
                              }`}
                            >
                              {size}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                <div className="filter">
                  <div className="filter_title flex gap-2 relative">
                    COLORS
                    {selectedColors.length >= 1 && (
                      <div>({selectedColors.length})</div>
                    )}{" "}
                  </div>
                  <div className="flex items-center gap-2 flex-wrap pt-5 lg:justify-between">
                    {colors.map((color, index) => {
                      return (
                        <div
                          className="filter_color"
                          key={index}
                          onClick={() => handleSelectedColor(color)}
                        >
                          <div
                            className={`w50px] h[40px]   ${
                              selectedColors.includes(color) &&
                              "borderred-500 border2"
                            }  flex justify-center items-center rounded-md`}
                          >
                            <div
                              className={`filter_item ${color.toLowerCase()}`}
                            >
                              {selectedColors.includes(color) && (
                                <div className="item_check">
                                  <IoIosCheckmark />
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="filter_item_label">{color}</div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div> */}

            <div className="right_filter_products">
              {/* <div className="mobile_filters_menus_container">
                <div
                  className="filter_btn"
                  onClick={() => {
                    handleMobileFilterMenuModal();
                  }}
                >
                  FILTERS <IoFilter size={15} />
                </div>
                {isMobileFilterMenuModal && (
                  <div className="mobile_product_filters">
                    <div className="flex gap-1 justify-between items-center  mobile_filters_header">
                      <div className="lg:text-[17px] text-[15px] font-medium tracking-widest uppercase ">
                        Filters
                      </div>
                      <div
                        onClick={() => {
                          handleMobileFilterMenuModal();
                        }}
                      >
                        <IoClose size={25} />
                      </div>
                    </div>

                    <div className="flex flex-col gap-3 pt-8">
                      <div className="filter">
                        <div className="filter_title relative">CATEGORIES</div>
                        <div className="flex flex-col gap-[6px] pt-5 categories">
                          {[
                            "All Categories",
                            "Sneakers",
                            "Running Shoes",
                            "Casual Shoes",
                            "Formal Shoes",
                          ].map((category) => (
                            <div
                              key={category}
                              className={`category ${
                                selectedCategory === category ? "active" : ""
                              }`}
                              onClick={() => handleSelectedCategory(category)}
                            >
                              {category}
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="filter">
                        <div className="filter_title relative">PRICE</div>
                        <div className="flex flex-col gap-[6px] pt-5 categories">
                          {priceOptions.map((option, index) => {
                            return (
                              <div
                                className="flex justify-between items-center"
                                key={index}
                              >
                                <div
                                  className={`category ${
                                    selectedPriceRangeId === option.id
                                      ? "active"
                                      : ""
                                  }`}
                                  onClick={() =>
                                    handleSelectPriceRange(option.id)
                                  }
                                >
                                  {option.label}
                                </div>
                                <div className="checkbox-wrapper-46">
                                  <input
                                    type="checkbox"
                                    checked={selectedPriceRangeId === option.id}
                                    id={`cbx-46`}
                                    className="inp-cbx"
                                    readOnly
                                  />
                                  <label htmlFor={`cbx-46`} className="cbx">
                                    <span>
                                      <svg
                                        viewBox="0 0 12 10"
                                        height="10px"
                                        width="12px"
                                      >
                                        <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                                      </svg>
                                    </span>
                                  </label>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      <div className="filter">
                        <div className="filter_title flex gap-2 relative">
                          SIZE
                        </div>
                        <div className="flex items-center gap-2 flex-wrap pt-5 justify-between">
                          <div className="flex  lg:justify-between items-center lg:gap-2 gap-3  flex-1 flex-wrap">
                            {sizes.map((size, index) => {
                              return (
                                <div
                                  key={index}
                                  className="w-[43px] h-[37px]"
                                  onClick={() => handleSelectedSizes(size)}
                                >
                                  <div
                                    className={`borde borderblack rounded-md w-full h-full flex justify-center bg-white items-center text-black ${
                                      selectedSizes.includes(size) &&
                                      "!bg-black !text-white"
                                    }`}
                                  >
                                    {size}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>

                      <div className="filter">
                        <div className="filter_title flex gap-2 relative">
                          COLORS
                          {selectedColors.length >= 1 && (
                            <div>({selectedColors.length})</div>
                          )}{" "}
                        </div>
                        <div className="flex items-center gap-2 flex-wrap pt-5 lg:justify-between">
                          {colors.map((color, index) => {
                            return (
                              <div
                                className="filter_color"
                                key={index}
                                onClick={() => handleSelectedColor(color)}
                              >
                                <div
                                  className={`w50px] h[40px]   ${
                                    selectedColors.includes(color) &&
                                    "borderred-500 border2"
                                  }  flex justify-center items-center rounded-md`}
                                >
                                  <div
                                    className={`filter_item ${color.toLowerCase()}`}
                                  >
                                    {selectedColors.includes(color) && (
                                      <div className="item_check">
                                        <IoIosCheckmark />
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="filter_item_label">{color}</div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div> */}
              <section>
                <ProductsPageCard
                  allProducts={currentItems as IProduct[]}
                  isLoading={getAllProducts.data === undefined ? true : false}
                />
                {currentItems.length !== 0 && (
                  <div className="pagination_container">
                    <ReactPaginate
                      pageCount={totalPages}
                      onPageChange={handlePageChange}
                      previousLabel={"← Previous"}
                      nextLabel={"Next →"}
                      containerClassName={"pagination flex gap-2 mt-4"}
                      activeClassName={"font-bold"}
                      pageRangeDisplayed={2}
                      marginPagesDisplayed={1}
                      renderOnZeroPageCount={null}
                    />
                  </div>
                )}
              </section>
            </div>
          </div>
        </div>
      </div>
      {/* <section>
        <Reviews />
      </section> */}
    </>
  );
};

export default Products;
